import React from 'react'

import { DEFAULT_FONT_SIZES } from '../_defaults/fontSizes'
import { ThemeContext } from '../ThemeHandler'
import { getSmartSize } from '../../../utils/helpers/styles'

export const useFontSizes = () => React.useContext(ThemeContext)?.fontSizes || DEFAULT_FONT_SIZES

export const useFontSize = (size, defaultSize) => {
  const fontSizes = useFontSizes()
  return getSmartSize(size, fontSizes, defaultSize)
}
